function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  stroke: "#000126",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M14 11.28v2c.002.375-.155.734-.432.988s-.647.38-1.021.345c-2.052-.223-4.022-.924-5.754-2.046-1.61-1.024-2.976-2.39-4-4C1.667 6.827.965 4.847.747 2.787c-.034-.373.09-.743.343-1.02.252-.276.609-.433.983-.434h2c.67-.006 1.24.484 1.334 1.147.084.64.24 1.268.466 1.873.183.488.066 1.037-.3 1.407l-.846.847c.949 1.669 2.33 3.05 4 4l.846-.847c.37-.366.92-.483 1.407-.3.605.226 1.233.382 1.873.467.67.094 1.164.676 1.147 1.353z",
  clipRule: "evenodd"
});

var SvgPhone = function SvgPhone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPhone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/phone.4bae70f3.svg";
export { ForwardRef as ReactComponent };